import { useEffect, useState } from "react";
import { api, getUser } from "@/lib/api";
import Dashboard from "@/pages/Dashboard";
import StationHome from "@/pages/StationHome";

/**
 * Decide qual "home" mostrar em "/":
 * - Se o usuário tem permissão `dashboard` → Dashboard cheio.
 * - Se não tem (típico de estações restritas) → StationHome (logo + relógio).
 * Admin real sempre vê o Dashboard.
 */
export default function HomeGate() {
  const user = getUser();
  const [ready, setReady] = useState(false);
  const [canDashboard, setCanDashboard] = useState(true);

  useEffect(() => {
    // Admin real sempre vê o Dashboard.
    if (user?.role === "admin" && !user?.is_station) {
      setCanDashboard(true);
      setReady(true);
      return;
    }
    let cancelled = false;
    api.get("/permissions/me")
      .then(({ data }) => {
        if (cancelled) return;
        setCanDashboard(!!(data?.permissions || {}).dashboard);
      })
      .catch(() => { if (!cancelled) setCanDashboard(false); })
      .finally(() => { if (!cancelled) setReady(true); });
    return () => { cancelled = true; };
  }, [user?.role, user?.is_station]);

  if (!ready) {
    return <div className="p-10 text-zinc-400" data-testid="home-gate-loading">Carregando…</div>;
  }
  return canDashboard ? <Dashboard /> : <StationHome />;
}
